export const CommandsIds = {
    HIDE: 'components/hide',
    SHOW: 'components/show',
    COPY_LAYOUT_AND_STYLE: 'components/copy_layout_and_style',
    FILL: 'components/fillCommand',
    UNFILL: 'components/unfillCommand',
    DUPLICATE: 'components/duplicateCommand',
    DELETE: 'components/deleteCommand',
    MOVE_TO_BACK: 'components/MoveToBackCommand',
    MOVE_FORWARD: 'components/moveForwardCommand',
    MOVE_TO_FRONT: 'components/moveToFrontCommand',
    MOVE_BACKWARD: 'components/moveBackwardCommand',
    ORDER_DOM: 'components/orderDOM',
    MOVE_UP_1_PX: 'MOVE_UP_1_PX',
    MOVE_DOWN_1_PX: 'MOVE_DOWN_1_PX',
    MOVE_LEFT_1_PX: 'MOVE_LEFT_1_PX',
    MOVE_RIGHT_1_PX: 'MOVE_RIGHT_1_PX',
    MOVE_UP_10_PX: 'MOVE_UP_10_PX',
    MOVE_DOWN_10_PX: 'MOVE_DOWN_10_PX',
    MOVE_LEFT_10_PX: 'MOVE_LEFT_10_PX',
    MOVE_RIGHT_10_PX: 'MOVE_RIGHT_10_PX',
    CANCEL_ATTACH_CANDIDATE: 'components/attachCandidateCancel',
    MAKE_EVERYONE_LIKE_ME: 'components/makeEveryoneLikeMe',
    REMOVE_OVERRIDE: 'components/removeOverrideCommand',
    INTERACTIONS_REMOVE_OVERRIDE: 'components/removeInteractionsOverrideCommand',
    CUT: 'components/cutCommand',
    COPY: 'components/copyCommand',
    PASTE: 'components/pasteCommand',
    ADD_ANCHOR: 'components/addAnchor',
    ANCHOR_SETTINGS: 'components/anchorSettings',
    RESTORE_TO_VIEWPORT: 'components/restoreToViewport',
    ROTATE_90: 'components/rotate90',
    ROTATE_270: 'components/rotate270',
    FLIP_VERTICALLY: 'components/flipVertically',
    FLIP_HORIZONTALLY: 'components/flipHorizontally',
    COPY_FORMATTING_SIMPLE: 'components/copyFormattingSimple',
    COPY_FORMATTING_INCLUDE_BREAKPOINTS: 'components/copyFormattingIncludeBreakpoints',
    SAVE_AS_PRESET: 'responsivePreset/saveAsPreset',
    SAVE_AS_USER_PRESET: 'responsiveUserPreset/saveAsUserPreset',
    SAVE_DESIGN_ASSET: 'designLibraries/savePreset',
    ALIGN_TO_LEFT: 'components/align_left',
    ALIGN_TO_CENTER_HORIZONTALLY: 'components/align_centerHorizontally',
    ALIGN_TO_RIGHT: 'components/align_right',
    ALIGN_TO_TOP: 'components/align_top',
    ALIGN_TO_CENTER_VERTICALLY: 'components/align_centerVertically',
    ALIGN_TO_BOTTOM: 'components/align_bottom',
    SELECT_HIDDEN_BY_COMPONENT: 'components/selectHiddenByComponent',
    SHOW_SHORTCUT_LIST: 'responsive/showShortcutList',
    NONE_SCROLL_POSITION: 'components/noneScrollPosition',
    FIXED_SCROLL_POSITION: 'components/fixedScrollPosition',
    STICKY_SCROLL_POSITION: 'components/stickyScrollPosition',
    GROUP: 'components/group',
    UNGROUP: 'components/ungroup',
    REMOVE_FROM_GROUP: 'components/removeFromGroup',
    APPLY_GRID: 'gridSection/addGridDialog',
    EDIT_GRID: 'gridSection/editGrid',
    GRID_SLICE_MODE: 'grid/sliceMode',
    GRID_SECTION_CUSTOMIZE_GRID_ON_CANVAS: 'gridSection/customizeGridOnCanvas',
    GRID_RULER_INDICATION: 'grid/rulerIndication',
    POSITION_INDICATIONS: 'positionIndications',
    FLIP_SECTION: 'gridSection/flip',
    MOVE_SECTION_BACK: 'gridSection/moveBack',
    MOVE_SECTION_FORWARD: 'gridSection/moveForward',
    CORVID_CODE_PROPS: 'corvid-developer-toolbar/toggle',
    ADD_ORGANIZER_ITEM: 'organizer/add-item',
    ADD_ADJACENT_ORGANIZER_ITEM: 'organizer/add-adjacent-item',
    ADD_ADJACENT_ORGANIZER_ITEM_AFTER: 'organizer/add-adjacent-item-after',
    ADD_ADJACENT_ORGANIZER_ITEM_BEFORE: 'organizer/add-adjacent-item-before',
    ORGANIZER_ITEM_FORWARD: 'organizer/switch-item-forward',
    ORGANIZER_ITEM_BACKWARD: 'organizer/switch-item-backward',
    COPY_FROM_BREAKPOINT: 'breakpoints/copyFrom',
    TOGGLE_LAYERS_PANEL_COMMAND_ID: 'layers-panel/toggle',
    HISTORY_UNDO_COMMAND_ID: 'editor-history/undo',
    HISTORY_REDO_COMMAND_ID: 'editor-history/redo',
    TOGGLE_INSPECTOR_PANEL_COMMAND_ID: 'inspector/togglePanel',
    TOGGLE_COMMENTS_PANEL_COMMAND_ID: 'comments-panel/toggle',
    TOGGLE_COMMENTS_PANEL_ON_COMPONENT_COMMAND_ID: 'comments-panel/toggle-on-component',
    STACK: 'editor-stack/stack',
    UNSTACK: 'editor-stack/unstack',
    WRAP_WITH_CONTAINER: 'editor-container/wrap-with-container',
    UNCONTAIN: 'editor-container/uncontain',
    ACCESSIBILITY: 'accessibility/accessibility',
    QUICK_ADD: 'quickAdd',
    QUICK_ADD_TITLE: 'quickAdd/title',
    QUICK_ADD_PARAGRAPH: 'quickAdd/paragraph',
    QUICK_ADD_BUTTON: 'quickAdd/button',
    QUICK_ADD_IMAGE: 'quickAdd/image',
    QUICK_ADD_VIDEO: 'quickAdd/video',
    QUICK_ADD_VIDEO_PLAYER: 'quickAdd/video-player',
    QUICK_ADD_CONTAINER: 'quickAdd/container',
    QUICK_ADD_SECTION: 'quickAdd/section',
    QUICK_ADD_VERTICAL_SECTION: 'quickAdd/vertical-section',
    QUICK_ADD_LAYOUTER: 'quickAdd/layouter',
    QUICK_ADD_SHAPE: 'quickAdd/shape',
    RENAME_LAYER: 'components/renameLayer',
    REPEATER_ITEM_FORWARD: 'repeater/switch-item-forward',
    REPEATER_ITEM_BACKWARD: 'repeater/switch-item-backward',
    MOVE_TO_SLOT: 'widget-plugins/move-to-slot',
    RESPONSIVE_PANELS_TOGGLE: 'responsive-panels/toggle',
};
export const CommandsIdsGroups = {
    AnchorCommands: [CommandsIds.ADD_ANCHOR, CommandsIds.ANCHOR_SETTINGS],
    CopyFormattingCommands: [
        CommandsIds.COPY_FORMATTING_SIMPLE,
        CommandsIds.COPY_FORMATTING_INCLUDE_BREAKPOINTS,
    ],
    AlignCommands: [
        CommandsIds.ALIGN_TO_LEFT,
        CommandsIds.ALIGN_TO_CENTER_HORIZONTALLY,
        CommandsIds.ALIGN_TO_RIGHT,
        CommandsIds.ALIGN_TO_TOP,
        CommandsIds.ALIGN_TO_CENTER_VERTICALLY,
        CommandsIds.ALIGN_TO_BOTTOM,
    ],
    ScrollCommands: [
        CommandsIds.NONE_SCROLL_POSITION,
        CommandsIds.FIXED_SCROLL_POSITION,
        CommandsIds.STICKY_SCROLL_POSITION,
    ],
    ArrangePositionCommands: [
        CommandsIds.MOVE_FORWARD,
        CommandsIds.MOVE_BACKWARD,
        CommandsIds.MOVE_TO_BACK,
        CommandsIds.MOVE_TO_FRONT,
    ],
    ShowHideCommands: [CommandsIds.SHOW, CommandsIds.HIDE],
    QuickAddCommands: [
        CommandsIds.QUICK_ADD_TITLE,
        CommandsIds.QUICK_ADD_PARAGRAPH,
        CommandsIds.QUICK_ADD_BUTTON,
        CommandsIds.QUICK_ADD_IMAGE,
        CommandsIds.QUICK_ADD_VIDEO,
        CommandsIds.QUICK_ADD_VIDEO_PLAYER,
        CommandsIds.QUICK_ADD_CONTAINER,
        CommandsIds.QUICK_ADD_SECTION,
        CommandsIds.QUICK_ADD_VERTICAL_SECTION,
        CommandsIds.QUICK_ADD_LAYOUTER,
        CommandsIds.QUICK_ADD_SHAPE,
    ],
};
export const MenuCommandsIds = {
    EDIT: 'menuItem/edit',
    RENAME: 'menuItem/rename',
    DELETE: 'menuItem/delete',
    OPEN_PAGES_PANEL: 'menuItem/openPagesPanel',
    CHANGE_NESTING: 'menuItem/changeNesting',
};
export const PermissionsCommandsIds = {
    MANAGE_TEAM: 'permissions/manageTeam',
    MANAGE_ROLES: 'permissions/manageRoles',
    INVITE_TO_TEAM: 'permissions/inviteToTeam',
    INVITE_TO_SITE: 'permissions/inviteToSite',
};
export const PageCommandsIds = {
    SETTINGS: 'pages/settings',
    TRANSLATE_PAGE_NAME: 'pages/translatePageName',
    SEO: 'pages/seo',
    SOCIAL: 'pages/social',
    RENAME: 'pages/rename',
    DUPLICATE: 'pages/duplicate',
    SET_AS_DYNAMIC_PAGE: 'pages/setAsDynamicPage',
    DELETE: 'pages/delete',
    SET_AS_HOME_PAGE: 'pages/setAsHomePage',
    EDIT_PAGE_BACKGROUND_COMMAND_ID: 'page/editPageBackground',
};
export const TopbarCommandsIds = {
    SHARE_SITE: 'topbar/share-site',
    PREVIEW: 'topbar/preview',
    SAVE: 'topbar/save',
    PUBLISH: 'topbar/publish',
    UNDO: 'topbar/undo',
    REDO: 'topbar/redo',
    VIEW_PUBLISHED: 'topbar/view_published',
    SITE_HISTORY: 'topbar/site-history',
    CREATE_NEW_SITE: 'topbar/create-new-site',
    SEO: 'topbar/seo',
    DASHBOARD: 'topbar/dashboard',
    SOCIAL: 'topbar/social',
    ROLES: 'topbar/roles',
    INVITE: 'topbar/invite',
    INFO: 'topbar/info',
    DOMAINS: 'topbar/domains',
    MAILBOXES: 'topbar/mailboxes',
    PAYMENTS: 'topbar/payments',
    NOTIFICATIONS: 'topbar/notifications',
    TRACKING: 'topbar/tracking',
    RELEASE_MANAGER: 'topbar/release-manager',
    CUSTOMER_MANAGEMENT: 'topbar/customer-manager',
    MARKETING: 'topbar/marketing',
    HELP_CENTER: 'topbar/help-center',
    ACADEMY: 'topbar/academy',
    FORUM: 'topbar/forum',
    UPDATES_RELEASES: 'topbar/updates-releases',
    SHORTCUTS: 'topbar/shortcuts',
    DUPLICATE: 'topbar/duplicate',
    TRANSFER: 'topbar/transfer',
    RENAME: 'topbar/rename',
    RENAME_FROM_EDITOR: 'topbar/rename-from-editor',
    AUTOSAVE_ON: 'topbar/autosave-on',
    AUTOSAVE_OFF: 'topbar/autosave-off',
    UPGRADE: 'topbar/upgrade',
    CONTACT_SUPPORT: 'topbar/contact-support',
    SEND_FEEDBACK: 'topbar/send-feedback',
    GET_FEEDBACK: 'topbar/get-feedback',
    REQUEST_FEATURE: 'topbar/request-feature',
    REPORT_BUG: 'topbar/report-bug',
    WELCOME_TOUR: 'topbar/welcome-tour',
    ORIENTATION_TOUR: 'topbar/orientation-tour',
    ZOOM_IN: 'topbar/zoom-in',
    ZOOM_OUT: 'topbar/zoom-out',
    ZOOM_RESET: 'topbar/zoom-reset',
    DARK_MODE: 'topbar/dark-mode',
    ADD_APP: 'topbar/add-app',
    DESIGN_LIBRARIES: 'topbar/design-libraries',
    MEDIA_MANAGER: 'topbar/media-manager',
    SITE_CHECK: 'topbar/site-health-check',
    MARKETPLACE: 'topbar/marketplace',
    CREATE_RC: 'topbar/create-rc',
    CODE_PROPERTIES: 'topbar/code-properties',
    HIDDEN_ELEMENTS: 'topbar/hidden-elements',
    CONCURRENT_EDITING_TOUR: 'topbar/concurrent-editing-tour',
    IMPORT_TOUR: 'topbar/import-tour',
    PERMISSIONS_PER_PAGE: 'topbar/permissions-per-page',
    PARENT_CONTAINER_FIRST: 'topbar/parent-container-first',
    CHILD_ELEMENT_FIRST: 'topbar/child-element-first',
    MIGRATION_RESTORE: 'topbar/migration-restore',
    DSL_UPLOAD: 'topbar/dsl-upload',
    GLOBAL_NOTIFICATIONS: 'topbar/global-notifications',
    MULTILINGUAL: 'topbar/multilingual',
    CLICK_INTERACTION_TOUR: 'topbar/click-interactions-tour',
    DEMO: 'topbar/demo',
    SHARE_SITE_TOUR: 'topbar/share-site-tour',
    GRID_RULER_INDICATION: 'topbar/grid-size-on-canvas',
    POSITION_INDICATIONS: 'topbar/position-indications',
};
export const SiteCheckCommandsIds = {
    TOGGLE_IGNORE: 'TOGGLE_IGNORE',
    FIX_ISSUE: 'FIX_ISSUE',
};
//# sourceMappingURL=commandsIds.js.map